import drumKit from "./assets/drum-kit.png";
import simonGame from "./assets/simon-game.png";
import bmiCalc from "./assets/bmi-calc.png";
import xo from "./assets/xo.png";
import ecoSolutions from "./assets/ecosolutions.png";



const projectDetails = {
    drumKit: [
        "Drum Kit",
        drumKit,
        "https://www.github.com",
        "Built a virtual drum kit using HTML, CSS, and JavaScript for interactive exploration of percussion sounds and web development concepts."
    ],
    simonGame: [
        "Simon Game",
        simonGame,
        "https://www.github.com",
        "Built a Simon Says memory game using HTML, CSS, JavaScript, and jQuery. Leveraged jQuery for efficient DOM manipulation and enhanced user interaction."
    ],
    bmiCalc: [
        "BMI Calculator",
        bmiCalc,
        "https://bmi-calculator-topaz-ten.vercel.app",
        "Built an interactive BMI calculator with React, showcasing proficiency in component-based UI development."
    ],
    XO: [
        "Tic-Tac-Toe",
        xo,
        "https://xo-game-d49d8.web.app/",
        "Developed a two player Tic-Tac-Toe game using React and Firebase. Implemented game logic, and state management."
    ],
    ecoSolutions: [
        "Eco Solutions",
        ecoSolutions,
        "https://eccosolutions.netlify.app/",
        "Built an e-commerce web application for sustainable products using React and Firebase. Implemented product listings, user authentication, shopping cart functionality, and a secure checkout process."
    ],
}

export default projectDetails;

